import React, { useEffect, useState } from 'react';
import { useT } from '../lib/i18n';

const SEEN_KEY = 'ctl_pwa_install_dismissed';

function isStandalone() {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia?.('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}

function isIOSSafari() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  const ios = /iPad|iPhone|iPod/.test(ua);
  const safari = /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS/.test(ua);
  return ios && safari;
}

export default function InstallHint() {
  const { lang } = useT();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isStandalone()) return;
    if (!isIOSSafari()) return;
    try {
      if (localStorage.getItem(SEEN_KEY)) return;
    } catch (_) {}
    const t = setTimeout(() => setShow(true), 8000);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    setShow(false);
    try { localStorage.setItem(SEEN_KEY, '1'); } catch (_) {}
  };

  if (!show) return null;

  const fi = {
    line1: 'Lisää kotinäytölle.',
    line2: 'Jaa-painike alapalkista → Lisää kotivalikkoon.',
    close: 'Sulje',
  };
  const en = {
    line1: 'Add to home screen.',
    line2: 'Share button at the bottom → Add to Home Screen.',
    close: 'Dismiss',
  };
  const txt = lang === 'fi' ? fi : en;

  return (
    <div
      className="fixed left-4 right-4 bottom-4 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-sm bg-[#F2EEE6] border border-[#2A2724]/15 px-5 py-4 z-50 shadow-sm fade-in"
      data-testid="install-hint"
      role="status"
    >
      <p className="text-sm font-bold text-[#2A2724] mb-1">{txt.line1}</p>
      <p className="text-xs text-[#2A2724] opacity-70 leading-relaxed">{txt.line2}</p>
      <button
        type="button"
        onClick={dismiss}
        className="absolute top-2 right-3 text-[#2A2724] opacity-50 hover:opacity-100 text-xs"
        aria-label={txt.close}
        data-testid="install-hint-dismiss"
      >
        ×
      </button>
    </div>
  );
}
